var COMMONGIFTURL = 'https://mgate.didistatic.com/static/mgate/';
// 余额代扣协议书
var BALANCEAGREEMENTURL = 'remaining-deductions-attorney.pdf';
// 合同模板
var CONTACTTEMPLATE = 'dafs-contract-template.png';
// 收租流程
var COLLECTRENT = 'dafs-collect-rent.png';
// 全桔介绍文档
var SYSTEMINSTRUCTION = 'dafs-product-manual.pdf';
export { COMMONGIFTURL, BALANCEAGREEMENTURL, CONTACTTEMPLATE, COLLECTRENT, SYSTEMINSTRUCTION };
